const COMPANIES = [
  "IBM",
  "Microsoft",
  "Google",
  "Deloitte",
  "Accenture",
  "EY",
  "AWS",
  "PwC",
  "Audi",
  "BMW",
  "Allianz",
  "Deutsche Bank",
  "BioNTech",
  "Siemens",
  "and many more"

];

export function LogoMarquee() {
  return (
    <div className="overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
      <div className="group flex w-max items-center gap-16 animate-marquee hover:[animation-play-state:paused]">
        {[...COMPANIES, ...COMPANIES].map((company, i) => (
          <div
            key={`${company}-${i}`}
            className="
              flex
              h-12
              w-20
              shrink-0
              items-center
              justify-center
            "
          >
            <span
              className="
                whitespace-nowrap
                text-sm
                font-semibold
                tracking-wide
                text-slate-600
                transition-colors
                duration-300
                group-hover:text-slate-700
              "
            >
              {company}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}